import { useEffect, useRef } from "react";
import { createSilkBackground } from "../lib/silkBackground";
export default function SilkBackground() {
  const ref = useRef(null);
  useEffect(() => {
    const silk = createSilkBackground(ref.current, "/media/duoclair-seta.webp");
    return () => silk.destroy();
  }, []);
  return (
    <div className="silk-bg" aria-hidden="true" style={{ backgroundImage: "url('/media/duoclair-seta-poster.jpg')" }}>
      <canvas ref={ref} />
      <div className="silk-scrim" />
    </div>
  );
}
